module.exports = __webpack_public_path__ + "static/media/31JFA9.0c31ac1c.jpg";